import {
  FileExtension,
  FilenameIdentifier,
} from '../models/product-data-filename-conventions/product-data-filename-convention';

const IDENTIFIER_PATTERN_TOKEN: Record<FilenameIdentifier, string> = {
  Barcode: '{barcode}',
  Reference: '{reference}',
  Description: '{description}',
};

const EXTENSION_TO_SUFFIX: Record<FileExtension, string> = {
  Json: 'json',
  Csv: 'csv',
};

export function buildFormatConvention(
  identifier: FilenameIdentifier,
  format: FileExtension,
): string {
  return `${IDENTIFIER_PATTERN_TOKEN[identifier]}.${EXTENSION_TO_SUFFIX[format]}`;
}
